import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import LightImg from '../../../assets/img/illustrations/auth-basic-reset-password-mask-light.png';
import DarkImg from '../../../assets/img/illustrations/auth-basic-reset-password-mask-dark.png';
import './index.scss';

const ResetPasswordIllustrations: React.FC = () => {
  const { theme } = useContext(AuthContext);
  const imgSrc = theme === 'dark' ? DarkImg : LightImg;

  return (
    <img 
      src={imgSrc} 
      alt="Reset password illustration" 
      className="auth-illustration"
    />
  );
};

export default ResetPasswordIllustrations;
